var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGitlab(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "logo art",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "120 110 350 350"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fc6d26",
    d: "m461.17 301.83-18.91-58.12-37.42-115.28a6.47 6.47 0 0 0-12.27 0l-37.42 115.21H230.82L193.4 128.43a6.46 6.46 0 0 0-12.26 0l-37.36 115.21-18.91 58.19a12.88 12.88 0 0 0 4.66 14.39L293 435l163.44-118.78a12.9 12.9 0 0 0 4.73-14.39"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e24329",
    d: "m293 434.91 62.16-191.28H230.87L293 434.91z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc6d26",
    d: "m293 434.91-62.18-191.28h-87L293 434.91z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fca326",
    d: "m143.75 243.69-18.91 58.12a12.88 12.88 0 0 0 4.66 14.39L293 435 143.75 243.69z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#e24329",
    d: "M143.78 243.69h87.11l-37.49-115.2a6.47 6.47 0 0 0-12.27 0l-37.35 115.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc6d26",
    d: "m293 434.91 62.16-191.28h87.14L293 434.91z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fca326",
    d: "m442.24 243.69 18.91 58.12a12.85 12.85 0 0 1-4.66 14.39L293 434.91l149.2-191.22z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#e24329",
    d: "M442.28 243.69h-87.1l37.42-115.2a6.46 6.46 0 0 1 12.26 0l37.42 115.2z"
  })));
}

export default SvgGitlab;